import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { css, html } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { overlayClasses } from "./utils.js";
import "../ClickOutside/index.js";
import "../FocusTrap/index.js";
import { classNames } from "../../../styles/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfModalBase = class extends BaseComponent {
  constructor() {
    super();
    this.dsf_hide_overlay = false;
    this.dsf_focus_selector = "input";
  }
  onOverlayClick() {
    this.emit("overlay-click");
  }
  onKeydown(e) {
    if (e.key === "Escape") {
      this.emit("escape");
    }
  }
  disableBodyScroll() {
    document.body.classList.add(classNames.disableScroll);
  }
  enableBodyScroll() {
    document.body.classList.remove(classNames.disableScroll);
  }
  connectedCallback() {
    super.connectedCallback();
    this.onKeydown = this.onKeydown.bind(this);
    document.addEventListener("keydown", this.onKeydown);
    this.disableBodyScroll();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("keydown", this.onKeydown);
    this.enableBodyScroll();
  }
  render() {
    return html`
      <div class=${overlayClasses(this)} part="overlay">
        <dsf-click-outside @click-outside=${this.onOverlayClick}>
          <dsf-focus-trap dsf_focus_selector=${ifDefined(this.dsf_focus_selector)}>
            <div
              class="flex max-h-screen flex-col rounded-sm bg-neutral-0 shadow-xxl mobile:w-screen"
              part="modal"
              role="dialog"
              aria-modal="true"
              aria-label="dialog"
            >
              <slot name="header"></slot>
              <slot name="content"></slot>
              <slot name="footer"></slot>
              <slot></slot>
            </div>
          </dsf-focus-trap>
        </dsf-click-outside>
      </div>
    `;
  }
};
DsfModalBase.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfModalBase.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        flex-grow: 1;
      }
    `
];
DsfModalBase.properties = {
  dsf_hide_overlay: { type: Boolean, reflect: true },
  dsf_focus_selector: { type: String }
};
DsfModalBase = __decorateClass([
  defineElement("dsf-modal-base")
], DsfModalBase);
export {
  DsfModalBase
};
